<template>
    <q-layout view="lhr lpr lfr">
        <q-header>
            <gfk-header :title="siteTitle" :subtitle="siteSubtitle">
                <template #right-top>
                    <router-link :to="{name:'caseidStart'}">Home</router-link> |
                    Logged in as <strong>{{ userDisplayName }}</strong> |
                    <router-link :to="{name: 'logout'}">Log out</router-link>
                </template>
            </gfk-header>
        </q-header>
        <q-separator/>
        <q-page-container>  
            <q-page class="q-pa-md gfk-q-pa-md">
                <div class="row q-col-gutter-md">
                    <div class="col-md-6 gfk-card">
                        <q-card class="my-card" >
                            <q-card-section class="bg-white" style="text-align: center;" >
                                <div class="row items-centergit ">
                                    <div class="no-wrap col">
                                        <h6>Create a new case.</h6>
                                        <p>To create a new case, you will need some information about that person.</p>
                                    </div>
                                </div>
                                <q-card-actions class="gfk_card__actions">
                                    <q-btn class="full-width" color="blue-10" label="Create" @click="createCase" />
                                </q-card-actions>
                            </q-card-section>
                        </q-card>
                    </div>
                    
                    <div class="col-md-6 gfk-card">
                        <q-card class="my-card">
                            <q-card-section class="bg-white" style="text-align: center;">
                                <div class="row items-centergit" >
                                    <div class="no-wrap col" style="width: 100%;">
                                        <h6>Search existing case.</h6>
                                        <q-input style="width:100%"  v-model="caseid" :error-message="caseIdErrorLabel"  :error="v$.caseid.$error"/>
                                    </div>
                                </div>
                                <q-card-actions class="gfk_card__actions">
                                    <q-btn class="full-width gfk-bg-primary text-white" label="Search" @click="searchCase" />
                                </q-card-actions>
                            </q-card-section>
                        </q-card>
                    </div>
                </div>
            </q-page>
        </q-page-container>
        <q-footer class="q-layout-footer">
            <gfk-footer/>
        </q-footer>
        <q-dialog v-model="opened">
            <div>
              <h4>You will be starting a new case.</h4>
              <q-btn
                      @click="createCase"
                      label="Close">
                  Close
              </q-btn>
            </div>
        </q-dialog>
    </q-layout>
</template>

<script>
    import {
        QLayout,
        QToolbar,
        QSelect,
        QInnerLoading,
        QSpinnerGears,
        QCard,
        QCardSection,
        QBtn,
        QInput,
        QDialog,
        Dialog,
        QCardActions,
        QField,
        QHeader,
        QPageContainer,
        QFooter,
        QSeparator,
        QPage,
        QSplitter
    } from 'quasar';
    import { reactive } from 'vue'
    import { useVuelidate } from '@vuelidate/core'
    import { integer, required } from '@vuelidate/validators';
    import authenticateApi from '../api/auth';
    import store from '../store';
    import {
        CREATE_CASEID,
        SEARCH_CASEID,
        LOAD_CATEGORIES,
        FIND_SEARCH_BY_CASEID,
        CASEID,
        SET_ACTIVE_SEARCH_ID,
        LOAD_SEARCH_RESULTS,
        SET_SEARCH_CRITERIA,
        LOAD_SEARCH_PROGRESS
    } from '../store/keys';

    import gfkHeader from './gfk-header.vue';
    import gfkFooter from './gfk-footer.vue';
    import siteData from '../mixins/site-data-mixin';

    export default {
        mixins: [siteData],
        setup(){
            const state = reactive({
                caseid: ''
            });
            const rules = {
                caseid: { required }
            }
            const v$ = useVuelidate(rules, state)
            return { state, v$ }
        },
        components: {
            QLayout,
            QToolbar,
            gfkHeader,
            gfkFooter,
            QSelect,
            QInnerLoading,
            QSpinnerGears,
            QCard,
            QCardSection,
            QBtn,
            QInput,
            QDialog,
            QCardActions,
            QField,
            QHeader,
            QPageContainer,
            QFooter,
            Dialog,
            QSplitter,
            QSeparator,
            QPage,
            QSplitter
        },
        props: {},
        data() {
            return {
                caseid: '',
                opened: false,
                caseidError: false,
                caseIdErrorLabel: 'Please enter valid case id'
            };
        },
        watch: {},
        computed: {
            userDisplayName() {
                return authenticateApi.getUsername();
            }
        },
        mounted() {

        },
        methods: {
            createCase() {
                store.dispatch(CREATE_CASEID).then(() => {
                    const caseId = store.getters[CASEID];
                    this.$q.dialog({
                      title: 'Case ID created',
                      message: `Created case ID ${caseId}, you can now perform a search`,
                      ok: 'Proceed'
                    }).onOk(()=>{
                        store.dispatch(LOAD_CATEGORIES).then(() => {
                            this.$router.push({name: 'searchStart'});
                        });
                    })
                }).catch(err => {
                    console.log(err);
                    this.$q.notify({
                        type: 'negative',
                        message: err.message || "Unbale to process request. Please check your vpn connection.",
                        timeout: 12000
                    });
                });
            },
            searchCase() {
                if(!this.caseid){
                    this.v$.caseid.$touch();
                    this.$q.notify({
                        type: 'negative',
                        message: this.caseIdErrorLabel,
                        timeout: 12000
                    });
                    return;
                }
                store.dispatch(SEARCH_CASEID, this.caseid).then(() => {
                  return store.dispatch(FIND_SEARCH_BY_CASEID, store.getters[CASEID]).then(response => {
                    if (response === 'no-search') {
                      store.dispatch(LOAD_CATEGORIES).then(() => {
                        this.$router.push({name: 'searchStart'});
                      });
                    } else if (Array.isArray(response)) {
                      const search = response.filter(resp => resp.status !== 'canceled' && resp.status !== 'error')[0];
                      if (!search) {
                        store.dispatch(LOAD_CATEGORIES).then(() => {
                          this.$router.push({name: 'searchStart'});
                        });
                      } else {
                        store.commit(SET_ACTIVE_SEARCH_ID, search.searchId);
                        store.commit(SET_SEARCH_CRITERIA, search.criteria);
                        if (['done', 'limit-reached'].includes(search.status)) {
                          store.dispatch(LOAD_SEARCH_RESULTS).then(() => {
                            this.$router.push({
                              name: 'searchRecordSelection'
                            });
                          });
                        } else {
                          store.dispatch(LOAD_SEARCH_PROGRESS).then(() => {
                            this.$router.push({
                              name: 'searchOverview'
                            });
                          });
                        }
                      }
                    } else {
                      throw new Error('Unknown internal state');
                    }
                  })
                }).catch((err) => {
                    this.caseidError = true;
                    console.log(`what's happening here? ${JSON.stringify(err)}`);
                    let errMesage= err || 'Unbale to process request. Please check your vpn connection.';
                    this.$q.notify({
                        type: 'negative',
                        message: errMesage,
                        timeout: 12000
                    });
                });
            }
        }
    };
</script>
